import { effect, inject, untracked, ElementRef, EffectCleanupRegisterFn, DOCUMENT } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { SCROLLBAR_CONTROL, ScrollbarAdapter } from '../scrollbar/scrollbar-adapter';
import { ViewportAdapter } from '../viewport/viewport-adapter';

export abstract class PointerEventsAdapter {

  // Reference to the ScrollViewport component
  protected readonly adapter: ViewportAdapter = inject(ViewportAdapter);

  // Reference to the Scrollbar control component
  protected readonly control: ScrollbarAdapter = inject(SCROLLBAR_CONTROL);

  // Reference to the Document element
  protected readonly document: Document = inject(DOCUMENT);

  // The native element of the directive
  readonly nativeElement: HTMLElement = inject(ElementRef<HTMLElement>).nativeElement;

  // Pointer events subscription (made public for testing purpose)
  _pointerEventsSub: Subscription;

  abstract get pointerEvents(): Observable<PointerEvent>;

  protected constructor() {
    effect((onCleanup: EffectCleanupRegisterFn) => {
      const disableInteraction: boolean = this.adapter.disableInteraction();

      untracked(() => {
        if (!disableInteraction) {
          this._pointerEventsSub = this.pointerEvents.subscribe();
        }

        onCleanup(() => this._pointerEventsSub?.unsubscribe());
      });
    });
  }
}
